import { render, staticRenderFns } from "./EditarEnvioLab400.vue?vue&type=template&id=a44d820e"
import script from "./EditarEnvioLab400.vue?vue&type=script&lang=js"
export * from "./EditarEnvioLab400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports